import { createContext, useContext } from 'react';
import { Breakpoints } from '../../types/Breakpoints';
import { Composition } from '../../types/api/Composition';
import noop from '../../lib/doNothing';

export const appContextInitialValue = {
  userInfo: {
    loggedIn: false,
    settings: {
      accessKeysEnabled: false,
      colorScheme: 'system' as const,
    },
  },
  editModeInfo: {
    available: false,
    active: false,
  },
  appVersion: undefined,
  portalConfiguration: {
    // eslint-disable-next-line camelcase
    son_portal_support_email: undefined,
    // eslint-disable-next-line camelcase
    son_page_confidentialLevel_highest: undefined,
  },
  headMetaInfo: {},
  availableSections: {
    pageManagement: false,
    navigation: false,
  },
  windowInnerWidth: Breakpoints.base,
  disableAccessKeys: noop,
  resetAccessKeys: noop,
  enableAccessKeys: noop,
};

export type AppContext = Pick<
  Composition,
  'userInfo' | 'headMetaInfo' | 'appVersion' | 'editModeInfo' | 'portalConfiguration' | 'pageInfo' | 'publicSessionKey'
> & {
  availableSections: {
    pageManagement: boolean;
    navigation: boolean;
  };
  windowInnerWidth: number;
  disableAccessKeys(): void;
  enableAccessKeys(): void;
  resetAccessKeys(): void;
};
const AppContext = createContext<AppContext>(appContextInitialValue);

AppContext.displayName = 'AppContext';

export const useAppContext = () => useContext(AppContext);

export const { Provider, Consumer } = AppContext;
export default AppContext;
